import { useEffect, useState } from "react";
import { TrainingAPI } from "../../api/TrainingAPI";
import { useSelector } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import {
  Select,
  InputNumber,
  Button,
  Tooltip,
  Divider,
  Dropdown,
  Space,
  Input,
  Typography,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';

import "../../Styles/styles-PostData.css";
import "../../Styles/styles-Settings.css";
import { useDispatch } from "react-redux";
import { getTeamPlayers } from "../../store/actions/team.actions";
import { getNestedPositionSelectOptions } from "../../Utils/position_utils";
import { PositionSelect } from "../PositionSelect/PositionSelect";
import { displayValidationErrorMessages } from "./TeamSettings";
import { 
  PermissionedInputNumber, 
  PermissionedButton 
} from "../PermissionedComponents";
import PermissionViewable from "../PermissionedComponents/PermissionViewable";

const { Option, OptGroup } = Select;

export const TeamBaseline = ({
  allMetrics,
  sport,
  getBaselineOverviewData,
}) => {
  const trainingAPI = new TrainingAPI();

  const { positions: teamPositions } = useSelector(({ team }) => team);

  const [position, setPosition] = useState(undefined);
  const [metricValues, setMetricValues] = useState({});

  const handleChange = (value) => {
    setPosition(value);
    trainingAPI
      .getBaseline(value)
      .then((data) => setMetricValues(data))
      .catch((e) => message.error("Error loading baseline values"));
  };

  const update = async () => {
    try {
      await trainingAPI.updateBaseline({
        position,
        ...allMetrics.reduce(
          (acc, metric) => ({
            ...acc,
            [metric.key]: metricValues[metric.key] || 0,
          }),
          {}
        ),
      })
      message.success("Baseline values updated");
      getBaselineOverviewData();
    } catch (error) {
      message.error("Error saving baseline values");
      getBaselineOverviewData();
    }

    try {
      const errorMessages = await trainingAPI.validateTeam();
      if(errorMessages && Array.isArray(errorMessages)) {
        displayValidationErrorMessages(errorMessages)
      }
    } catch (error) {
      message.error("Error performing team validation");
    }
  };

  return (
    <PermissionViewable 
      permissionCheck="ViewTeamBaselines"
      permissionMessage="You don't have permission to view team baselines"
    >
      <div style={{ width: 440, maxWidth: "100%" }}>
        <div className="team-baseline-input-wrap">
          <div className="team-baseline-input-label">Select position</div>
          <PositionSelect
            options={teamPositions}
            sport={sport}
            value={position}
            handleChange={handleChange}
          />
        </div>
        <Divider style={{ margin: "15px 0px" }} />
        {allMetrics
          .filter(
            (metric) =>
              ![
                "aerobic_training_effect",
                "anaerobic_training_effect",
                "top_speed",
                "top_speed_percent",
                "distance_per_minute",
                "trimp",
                "trimp_per_minute",
                "max_hr"              
              ].includes(metric.key)
          )
          .map(({ key, name }, i) => {
            return (
              <div className="team-baseline-input-wrap" key={key}>
                <div className="team-baseline-input-label">{name}:</div>
                <PermissionedInputNumber
                  type="number"
                  min="0"
                  step="1"
                  // className="team-baseline-input"
                  style={{ width: "100%" }}
                  disabled={position === undefined}
                  value={metricValues[key]}
                  onChange={(value) => {
                    setMetricValues((prev) => ({
                      ...prev,
                      [key]: value,
                    }));
                  }}
                  permissionCheck="EditTeamBaselines"
                />
              </div>
            );
          })}
        <div className="setting-baseline-item">
          {position === undefined ? (
            <Tooltip title="No position selected">
              <PermissionedButton type="primary" disabled permissionCheck="EditTeamBaselines">
                Update
              </PermissionedButton>
            </Tooltip>
          ) : (
            <PermissionedButton type="primary" onClick={update} permissionCheck="EditTeamBaselines">
              Update
            </PermissionedButton>
          )}
        </div>
      </div>
    </PermissionViewable>
  );
};
